import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { TranslateService } from "@ngx-translate/core";
import { InviteValidationDTO } from "app/data/schema/Invite/InviteValidationDTO";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { locale as portuguese } from "./i18n/pt";

export interface DialogData {
    validations: InviteValidationDTO[] | null;
    error: string | null;
}

@Component({
    selector: "app-users-import-errors-dialog",
    templateUrl: "./users-import-errors-dialog.component.html",
    styleUrls: ["./users-import-errors-dialog.component.scss"],
    animations: [fuseAnimations]
})
export class UsersImportErrorsDialogComponent {
    public displayedColumns: Array<string> = ["line", "email", "errors", "copy"];

    public pageIndex = 0;
    public pageSize = 5;

    error: string;
    constructor(
        public dialogRef: MatDialogRef<UsersImportErrorsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private translateService: TranslateService,
        private matSnackBar: MatSnackBar,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, portuguese, spanish);
        this.error = data.error;
    }

    skipTakeValidations(): InviteValidationDTO[] {
        const offset = this.pageIndex * this.pageSize;
        return this.data.validations.slice(offset, offset + this.pageSize);
    }

    msgCopy(): void {
        this.matSnackBar.open(this.translateService.instant("DIALOG.COPIED"), "OK", {
            verticalPosition: "top",
            duration: 3000
        });
    }

    load($event: any): void {
        this.pageIndex = $event.pageIndex;
        this.pageSize = $event.pageSize;
    }

    getTsvFromValidations(): string {
        const titles = "Linha\tEmail\tErrors";

        const tsvArray: string[] = this.data.validations.map((validation: InviteValidationDTO) => {
            return `${validation.line || ""}\t${validation.email || ""}\t${validation.errors
                .replace("\t", " ")
                .replace("\n", " ")}`; // Separa os itens por tab
        });

        const tsvString = `${titles}\n${tsvArray.join("\n")}`; // Concatena os títulos com os dados
        return tsvString;
    }
}
